import PropTypes from 'prop-types'
import React, { useState, useEffect } from "react"
import { CardTitle, Col, Label, Modal, ModalBody, ModalHeader, Row, Input, InputGroup } from "reactstrap"
import { useSelector, useDispatch } from "react-redux";
import Select from "react-select";
import CurrencyFormat from 'react-currency-format';
import Flatpickr from "react-flatpickr";
import PulseLoader from "react-spinners/PulseLoader";


const ModalEdit = ({ show, onSubmit, onCancel, data, submitting }) => {
    const dispatch = useDispatch()
    const [dataSource, setDataSource] = useState(data)
    const [dataSubmit, setDataSubmit] = useState([])
    const [isSubmit, setIsSubmit] = useState(false)
    const [optionAccountNumber, setOptionAccountNumber] = useState([]);
    const [optionAccount, setOptionAccount] = useState([]);
    const [optionPeriod, setOptionPeriod] = useState([]);
    const optionType = [
        { label: "CREDIT", value: "credit" },
        { label: "DEBIT", value: "debit" },
    ]
    const optionYesNo = [
        { label: "Yes", value: true },
        { label: "No", value: false },
    ]

    const { companies, accountNumbers, accounts, periods } = useSelector(state => ({
        companies: state.Company.companies,
        accountNumbers: state.AccountNumber.listAccountNumber,
        accounts: state.Account.listAccount,
        periods: state.Period.periods,
    }))

    useEffect(() => {
        if (accountNumbers) {
            setOptionAccountNumber(accountNumbers.map(item => {
                return { label: item.name, value: item.id }
            }))
        }
    }, [accountNumbers])

    useEffect(() => {
        if (accounts) {
            setOptionAccount(accounts.map(item => {
                return { label: item.name, value: item.id }
            }))
        }
    }, [accounts])

    useEffect(() => {
        if (periods) {
            setOptionPeriod(periods.map(item => {
                return { label: item.name, value: item.id }
            }))
        }
    }, [periods])

    useEffect(() => {
        setDataSource(data);
        setIsSubmit(false)
        // setSelectedAccount(null)
        // setSelectedAccountNumber(null)

        if (companies) {
            var temp = companies.filter(s => s.id == dataSource?.companyId)
            if (temp.length > 0) {
                setSelectedCompany({ label: temp[0].name, value: temp[0].id })
            }
        }
        // if (accountNumbers) {
        //     var temp = accountNumbers.filter(s => s.id == dataSource?.accountNumberId)
        //     if (temp.length > 0) {
        //         setSelectedAccountNumber({ label: temp[0].name, value: temp[0].id })
        //     }
        //     else {
        //         setSelectedAccountNumber(null)
        //     }
        // }
        // if (accounts) {
        //     var temp = accounts.filter(s => s.id == dataSource?.accountId)
        //     if (temp.length > 0) {
        //         setSelectedAccount({ label: temp[0].name, value: temp[0].id })
        //     }
        //     else {
        //         setSelectedAccount(null)
        //     }
        // }
        // if (periods) {
        //     var temp = periods.filter(s => s.id == dataSource?.periodId)
        //     if (temp.length > 0) {
        //         setSelectedPeriod({ label: temp[0].name, value: temp[0].id })
        //     }
        //     else {
        //         setSelectedPeriod(null)
        //     }
        // }

        // var tempType = optionType.filter(s => s.value == dataSource?.type?.toLowerCase())
        // if (tempType.length > 0) {
        //     setSelectedType(tempType[0])
        // }
        // else {
        //     setSelectedType(null)
        // }

        // var tempAdjustment = optionYesNo.filter(s => s.value == dataSource?.adjustment)
        // if (tempAdjustment.length > 0) {
        //     setSelectedAdjustment(tempAdjustment[0])
        // }
        // else {
        //     setSelectedAdjustment(null)
        // }

        // var tempFiscal = optionYesNo.filter(s => s.value == dataSource?.fiscal)
        // if (tempFiscal.length > 0) {
        //     setSelectedFiscal(tempFiscal[0])
        // }
        // else {
        //     setSelectedFiscal(null)
        // }
    }, [show])

    useEffect(() => {
        if (data) {
            setDataSubmit(Object.assign({}, data))
        }
    }, [data])

    function handleDateChange(e) {
        const dd = e[0].getDate().toString();
        const mm = e[0].getMonth() + 1;
        const yyyy = e[0].getFullYear();
        if (dataSubmit) {
            dataSubmit.date = String(yyyy).padStart(2, '0') + "-" + String(mm).padStart(2, '0') + "-" + String(dd).padStart(2, '0')
        }
    }

    function handleSelectAccount(val, i) {
        setDataSource((prevData) => {
            return prevData.map((item, idx) => {
                if (idx === i) {
                    return { ...item, accountId: val.value, selectedAccount: val };
                }
                return item;
            });
        });
    }

    function handleSelectAccountNumber(val, i) {
        setDataSource((prevData) => {
            return prevData.map((item, idx) => {
                if (idx === i) {
                    return { ...item, accountNumberId: val.value, selectedAccountNumber: val };
                }
                return item;
            });
        });
    }

    function handleSelectPeriod(val, i) {
        setDataSource((prevData) => {
            return prevData.map((item, idx) => {
                if (idx === i) {
                    return { ...item, periodId: val.value, selectedPeriod: val };
                }
                return item;
            });
        });
    }

    function handleSelectType(val, i) {
        setDataSource((prevData) => {
            return prevData.map((item, idx) => {
                if (idx === i) {
                    return { ...item, type: val.value, selectedType: val };
                }
                return item;
            });
        });
    }

    function handleNominalChange(val, i) {
        setDataSource((prevData) => {
            return prevData.map((item, idx) => {
                if (idx === i) {
                    return { ...item, nominal: isNaN(val.floatValue) ? 0 : val.floatValue };
                }
                return item;
            });
        });
    }

    function handleRemarksChange(val) {
        if (dataSubmit) {
            dataSubmit.remarks = val
        }
    }

    const styleModal = {
        minWidth: '1400px',
    };

    return (
        <Modal isOpen={show} toggle={onCancel} centered={true} backdrop="static" style={styleModal} scrollable={true}>
            <ModalHeader>
                <CardTitle>Account Classification</CardTitle>
            </ModalHeader>
            <ModalBody className="p-3">
                {
                    submitting && <div className="d-flex justify-content-center my-5">
                        <PulseLoader loading={submitting} color={'#FFF'} size={12} className="align-self-center" />
                    </div>
                }
                {
                    !submitting && dataSource.map((item, idx) => {
                        return <Row className="mb-3" key={item.id}>
                            <Col>
                                <Label>Date</Label><Label className="text-danger">*</Label>
                                <InputGroup>
                                    <Flatpickr
                                        className={"form-control d-block"}
                                        placeholder="Select Date"
                                        options={{
                                            dateFormat: "Y-m-d"
                                        }}
                                        onChange={e => handleDateChange(e)}
                                        value={item?.date}
                                    />
                                </InputGroup>
                            </Col>
                            <Col>
                                <Label>Account Number</Label><Label className="text-danger">*</Label>
                                <Select
                                    value={item.selectedAccountNumber}
                                    onChange={(e) => {
                                        handleSelectAccountNumber(e, idx)
                                    }}
                                    options={optionAccountNumber}
                                    isClearable={false}
                                    isDisabled={false}
                                    className="select2-selection"
                                    menuPosition="fixed"
                                />
                            </Col>
                            <Col>
                                <Label>Account</Label><Label className="text-danger">*</Label>
                                <Select
                                    value={item.selectedAccount}
                                    onChange={(e) => {
                                        handleSelectAccount(e, idx)
                                    }}
                                    options={optionAccount}
                                    isClearable={false}
                                    className="select2-selection"
                                    menuPosition="fixed"
                                />
                            </Col>
                            <Col>
                                <Label>Type</Label><Label className="text-danger">*</Label>
                                <Select
                                    value={item.selectedType}
                                    onChange={(e) => {
                                        handleSelectType(e, idx)
                                    }}
                                    options={optionType}
                                    isClearable={false}
                                    className="select2-selection"
                                    menuPosition="fixed"
                                />
                            </Col>
                            <Col>
                                <Label>Remarks</Label><Label className="text-danger">*</Label>
                                <Input
                                    defaultValue={item.remarks}
                                    type="text"
                                    className="form-control"
                                    onChange={e => {
                                        handleRemarksChange(e.target.value)
                                    }}
                                    placeholder={'Enter ...'}
                                />
                            </Col>
                            <Col>
                                <Label>Nominal</Label><Label className="text-danger">*</Label>
                                <CurrencyFormat value={item.nominal} thousandSeparator={'.'} decimalSeparator={','} decimalScale={0}
                                    onValueChange={(values) => {
                                        handleNominalChange(values, idx)
                                    }}
                                    customInput={Input} className="text-end" />
                            </Col>
                            <Col>
                                <Label>Period</Label><Label className="text-danger">*</Label>
                                <Select
                                    value={item.selectedPeriod}
                                    onChange={(e) => {
                                        handleSelectPeriod(e, idx)
                                    }}
                                    options={optionPeriod}
                                    isClearable={false}
                                    className="select2-selection"
                                    menuPosition="fixed"
                                />
                            </Col>
                        </Row>
                    })
                }
                {
                    !submitting && <Row>
                        <Col>
                            <div className="text-end mt-3">
                                <button
                                    type="button"
                                    className="btn btn-success ms-2"
                                    onClick={() => {
                                        setIsSubmit(true)
                                        onSubmit(dataSource)
                                    }}>
                                    {/* disabled={valid()}> */}
                                    Submit
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-danger ms-2"
                                    onClick={onCancel}>
                                    Cancel
                                </button>
                            </div>
                        </Col>
                    </Row>
                }
            </ModalBody>
        </Modal>
    )
}

ModalEdit.propTypes = {
    onSubmit: PropTypes.func,
    onCancel: PropTypes.func,
    show: PropTypes.any,
    data: PropTypes.any,
}

export default ModalEdit
